import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Particles from 'react-particles-js';
import style from './App.module.scss';

type Theme = 'darkTheme' | 'lightTheme';

const App: React.FC = () => {
  const [theme, setTheme] = useState<Theme>(() =>
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'darkTheme'
      : 'lightTheme'
    );
  const toggleTheme = useCallback(() =>
    setTheme(theme => theme === 'darkTheme' ? 'lightTheme' : 'darkTheme')
  , []);
  return (
    <div className={`${style.app} ${theme}`}>
      <Welcome toggleTheme={toggleTheme} />
    </div>
  );
}

function useScreenSize() {
  const [size, setSize] = useState(() => {
    const { height, width } = window.screen;
    return { height, width };
  });

  useEffect(() => {
    function updateSize() {
      const { height, width } = window.screen;
      setSize(curr => {
        if (curr.height !== height || curr.width !== width) {
          return { height, width };
        }
        return curr;
      });
    }
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize)
  });
  return size;
}

function Welcome(props: { toggleTheme: () => void }) {
  const { height, width } = useScreenSize();
  const numParticles = useMemo(() => Math.ceil(Math.max(height, width) * 0.06), [height, width]);

  return (
    <div className={`${style.welcome}`} style={{ position: 'relative' }}>
      <Particles
        width={`${width + 100}px`} height={`${height + 100}px`}
        params={{
          particles: {
            number: {
              value: numParticles
            },
            size: {
              value: 2
            },
            line_linked: {
              distance: 160,
            }
          },
          interactivity: {
            detect_on: 'window',
            events: {
              onhover: {
                enable: true,
                mode: 'repulse'
              }
            },
            modes: {
              repulse: {
                distance: 160
              }
            }
          }
        }} className={style.particles} />
      <div className={style.page}>
        <h1>Stephen Pryor</h1>
        <h3 onClick={props.toggleTheme}>Senior Software Engineer @ Microsoft</h3>
        <div className={style.logoGrid}>
          <a href="https://www.linkedin.com/in/stephenpryor/">
            <img src="linkedinLogo.png" alt="LinkedIn Logo" className={style.brandLogo} />
          </a>
          <a href="https://github.com/spryor">
            <img src="githubLogo.png" alt="Github Logo" className={style.brandLogo} />
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
